import { render } from "./SnehaSparshamApplication.vue?vue&type=template&id=2b9dcc73&scoped=true"
import script from "./SnehaSparshamApplication.vue?vue&type=script&lang=js"
export * from "./SnehaSparshamApplication.vue?vue&type=script&lang=js"

import "./SnehaSparshamApplication.vue?vue&type=style&index=0&id=2b9dcc73&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9dcc73"]])

export default __exports__